var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charts-poly"},[_c('div',{staticClass:"charts-poly-chart__canvas",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }